'use client';

import React, { useEffect } from 'react';
import {
  pausePerformanceLabLenisScroll,
  resumePerformanceLabLenisScroll,
} from 'utils/performanceLabLenisRegistry';

/**
 * Mount inside Performance Lab modal content only. Pauses Lenis while the
 * modal body is mounted (cleanup on unmount).

 * Document scroll itself is already locked by the shared `ModalProvider`
 * (components/shared/Modal.tsx), which wraps every one of this component's
 * callers — they're all rendered as modal content via `useModal()`. This
 * component used to lock `html`/`body` overflow a second time on top of that:
 * since this effect (mounting with the modal content) runs before the
 * ModalProvider's own scroll-lock effect (mounting one level up in the same
 * commit), the ModalProvider ended up capturing this component's `'hidden'`
 * as its "previous" value instead of the page's true original overflow — so
 * closing the modal restored to `'hidden'` instead of clearing it, leaving
 * the page permanently unscrollable. Locking scroll in exactly one place
 * removes that race.
 */
export const PerformanceLabModalBodyScrollLock: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  useEffect(() => {
    pausePerformanceLabLenisScroll();
    return () => {
      resumePerformanceLabLenisScroll();
    };
  }, []);

  return <>{children}</>;
};
